/**
 * Created by abbeymart on 2016-12-26.
 */
import type { RouteRecordRaw } from 'vue-router';

export const userGuideRoutes: Array<RouteRecordRaw> = [
  {
    path: '/userGuide',
    name: 'userGuide',
    component: () => import('pages/central/common/UserGuide.vue'),
    meta: {
      title: 'User Guides',
    },
  },
];
